import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Row, Col, Flex } from "antd";
import { Widget } from "../../../../Atomics/Widget";
import logger from "../../../../../../server/server";
import { useAuthContext } from "../../../../../../contexts/AuthContext";

export const BuildingEletricEnergy = () => {
  const { t } = useTranslation();
  const {user,tenant} = useAuthContext();
  useEffect(() => {
    logger.info("User: " + user?.Username + " is using BuildingEletricEnergy successfully! Tenant: " + tenant);
  }, []);
  const [showActiveChart, setShowActiveChart] = useState();

  return (
    <Row id="Energy" gutter={[16, 16]}>
      <Col span={6}>
        <Flex gap={16} vertical="true">
          <Widget
            data={{
              height: "150px",
              background: "white",
              title: t("Active Energy Consumption"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "bigNumberChart",
                  chartId: "bigNumberChartOne",
                  data: {
                    number: 30.52,
                    unit: "MWh",
                    type: null,
                    label: null,
                    fluctuation: "144.2",
                    fluctuationText: t("than") + " 2023",
                    bigFluctuation: false,
                    icon: "Bolt",
                  },
                },
              ],
            }}
          />
          <Widget
            data={{
              height: "150px",
              background: "white",
              title: t("Inductive Energy Consumption"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "bigNumberChart",
                  chartId: "bigNumberChartOne",
                  data: {
                    number: 42.8,
                    unit: "kVARh",
                    type: null,
                    label: null,
                    fluctuation: "-90.1",
                    fluctuationText: t("than") + " 2023",
                    bigFluctuation: false,
                    icon: "Bolt",
                  },
                },
              ],
            }}
          />
          <Widget
            data={{
              height: "150px",
              background: "white",
              title: t("Capacitive Energy Consumption"),
              icon: "Bolt",
              charts: [
                {
                  chartType: "bigNumberChart",
                  chartId: "bigNumberChartOne",
                  data: {
                    number: 3.68,
                    unit: "MVARh",
                    type: null,
                    label: null,
                    fluctuation: "121.1",
                    fluctuationText: t("than") + " 2023",
                    bigFluctuation: false,
                    icon: "Bolt",
                  },
                },
              ],
            }}
          />
        </Flex>
      </Col>
      <Col span={18}>
        <Widget
          data={{
            height: "482px",
            background: "white",
            title: t("Active Energy"),
            icon: "Bolt",
            charts: [
              {
                key: 0,
                chartType: "columnsChartApex",
                chartId: "barChartWithMultiXAxisOne",
                data: {
                  series: [
                    {
                      name: 2024,
                      data: [
                        {
                          x: "Jan",
                          y: 10.0205,
                        },
                        {
                          x: "Feb",
                          y: 8.336,
                        },
                        {
                          x: "Mar",
                          y: 7.62825,
                        },
                        {
                          x: "Apr",
                          y: 3.57075,
                        },
                        {
                          x: "May",
                          y: 0.858,
                        },
                        {
                          x: "Jun",
                          y: 0.107,
                        },
                        {
                          x: "Jul",
                          y: 0,
                        },
                        {
                          x: "Aug",
                          y: 0,
                        },
                        {
                          x: "Sep",
                          y: 0,
                        },
                        {
                          x: "Oct",
                          y: 0,
                        },
                        {
                          x: "Nov",
                          y: 0,
                        },
                        {
                          x: "Dec",
                          y: 0,
                        },
                      ],
                      unit: "MWh",
                    },
                    {
                      name: 2023,
                      data: [
                        {
                          x: "Jan",
                          y: 2.6345,
                        },
                        {
                          x: "Fev",
                          y: 2.1695,
                        },
                        {
                          x: "Mar",
                          y: 2.44175,
                        },
                        {
                          x: "Apr",
                          y: 2.36825,
                        },
                        {
                          x: "May",
                          y: 1.935,
                        },
                        {
                          x: "Jun",
                          y: 0.9475,
                        },
                        {
                          x: "Jul",
                          y: 0.8215,
                        },
                        {
                          x: "Aug",
                          y: 0.6945,
                        },
                        {
                          x: "Sep",
                          y: 1.08025,
                        },
                        {
                          x: "Oct",
                          y: 1.504,
                        },
                        {
                          x: "Nov",
                          y: 5.55475,
                        },
                        {
                          x: "Dec",
                          y: 9.545,
                        },
                      ],
                      unit: "MWh",
                    },
                  ],
                  categories: [],
                  xAxisType: null,
                  tooltip: null,
                  unit: "MWh",
                  columnWidth: 20,
                  xAxisLabel: null,
                  yAxisLabel: "MWh",
                  color: null,
                  filename: "Gráfico exportado",
                  headerValue: "valores",
                  headerCategory: "categorias",
                  showTooltipTitle: true,
                },
                height: '400px',
              },
            ],
            dropdowns: [
              {
                data: [
                  { label: t("Active Energy"), value: "Active Energy" },
                  {
                    label: t("Inductive Reactive Energy"),
                    value: "Inductive Reactive Energy",
                  },
                  {
                    label: t("Capacitive Reactive Energy"),
                    value: "Capacitive Reactive Energy",
                  },
                ],
                value: showActiveChart,
                functionChange: () => setShowActiveChart(!showActiveChart),
                width: "200px",
              },
            ],
          }}
        />
      </Col>
    </Row>
  );
};
